export const EMOJI_DATA = {
  emojiDisplay: false,
  emojiUrl: 'https://buffer.com/static/header/png/surfer.png',
  emojiLink: 'https://buffer.com/resources/closed-for-the-holidays/',
  emojiTooltip:
    'Buffer is now closed for the end of the year, learn more about how and why we close the whole company',
}
